/** Resolve a real pipeline stage id for a won deal (never use a fake id like "signed"). */
export function pickWonPipelineStageId(
  stages: Array<{ id: string; name: string; order: number }> | undefined,
): string | undefined {
  if (!stages?.length) return undefined;
  const sorted = [...stages].sort((a, b) => a.order - b.order);
  const byName = sorted.find((s) => /won|closed|signed|contract/i.test(s.name));
  return byName?.id ?? sorted[sorted.length - 1]?.id;
}
